export abstract class EditBlockBase {
    public data: any;
    public baseComponent: any;

    set component(component:any) {
        this.baseComponent = component;
        this.data = component.data;
    }
}
